export var IndexFileContentType;
(function (IndexFileContentType) {
    IndexFileContentType["NFT"] = "NFT";
    IndexFileContentType["CID"] = "CID";
    IndexFileContentType["MIRROR"] = "MIRROR";
    IndexFileContentType["VIDEO"] = "VIDEO";
    IndexFileContentType["WEBSITE"] = "WEBSITE";
})(IndexFileContentType || (IndexFileContentType = {}));
export var OriginType;
(function (OriginType) {
    OriginType[OriginType["curate"] = 0] = "curate";
    OriginType[OriginType["upload"] = 1] = "upload";
    OriginType[OriginType["follow"] = 2] = "follow";
    OriginType[OriginType["click"] = 3] = "click";
})(OriginType || (OriginType = {}));
export var FileType;
(function (FileType) {
    FileType[FileType["Public"] = 0] = "Public";
    FileType[FileType["Private"] = 1] = "Private";
    FileType[FileType["Datatoken"] = 2] = "Datatoken";
})(FileType || (FileType = {}));
